export type StudyLanguage = {
  languageCode: string;
  languageLabel: string;
};

export const resolveInitialLang = (
  studyLangs: StudyLanguage[],
  storedLang: string | null,
): string => {
  if (storedLang && studyLangs.some((l) => l.languageCode === storedLang)) {
    return storedLang;
  }

  if (navigator?.language && studyLangs.length > 0) {
    const navLang = navigator.language.split("-")[0];
    const matchedLang = studyLangs.find((l) => l.languageCode === navLang);
    if (matchedLang) {
      return matchedLang.languageCode;
    }
  }

  return "en";
};
